import { isInternalLink } from '@/contentful/utils';

export const appendQueryParams = (
  baseUrl: string,
  newParams: URLSearchParams
) => {
  const isInternal = isInternalLink(baseUrl);
  const base = 'https://example.com'; // temporary base for parsing relative URLs

  const url = new URL(baseUrl, base);

  newParams.forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  if (isInternal) {
    return url.pathname + url.search + url.hash;
  } else {
    return url.toString();
  }
};
